import { render, staticRenderFns } from "./score-pie.vue?vue&type=template&id=26530725&scoped=true"
import script from "./score-pie.vue?vue&type=script&lang=js"
export * from "./score-pie.vue?vue&type=script&lang=js"
import style0 from "./score-pie.vue?vue&type=style&index=0&id=26530725&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26530725",
  null
  
)

export default component.exports